import { ContentScriptAction, DashboardAction, isValidTab, safeSendChromeMessageToTab } from '@shared/extension';
import { Services } from '../services';

export async function sendDashboardMessage(
  services: Services,
  action: DashboardAction,
  detail?: Record<string, unknown>
): Promise<void> {
  const sendMessagePromise = new Promise<boolean>(resolve => {
    chrome.tabs.query({}, function (tabs) {
      let sent = false;
      tabs.forEach(function (tab) {
        if (!isValidTab(tab)) {
          return;
        }

        const isDashboard = tab.url.startsWith(services.environment.dashboardUrl);
        if (!isDashboard) {
          return;
        }
        safeSendChromeMessageToTab(tab.id!, {
          action: ContentScriptAction.SendDashboardMessage,
          detail: { action, detail },
        });
        sent = true;
      });
      resolve(sent);
    });
  });
  const sent = await sendMessagePromise;
  if (!sent) {
    await services.commonStore.setLatestDashboardMessage({ action, detail });
  }
}
